var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Nav'),_c('Stars'),_c('Cloud'),_c('Build'),_c('Store'),_c('CopyInfo'),_c('AboutUs'),_c('ContactUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }